import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/Icon';

const COPIED_FEEDBACK_MS = 2000;

/**
 * The Monograph's SMILES with its Copy button, shared by the Cards hero and the Sheet's
 * Identifiers (#1162). A molecule with a hapto bond says its SMILES are only its pieces
 * (ADR 0026 Q1), as Structure info says it in the editor. The caller supplies the wrapper.
 */
export function MonographSmiles({
  smiles,
  haptoBonds
}: {
  readonly smiles: string;
  readonly haptoBonds?: boolean | undefined;
}) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = globalThis.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
    return () => globalThis.clearTimeout(timer);
  }, [copied]);

  return (
    <>
      <code dir="ltr">{smiles}</code>
      <button
        type="button"
        className="monograph-sheet-action"
        onClick={() => {
          navigator.clipboard.writeText(smiles).then(
            () => setCopied(true),
            () => setCopied(false)
          );
        }}
      >
        <Icon name="copy" size="1.05rem" />
        <span>{copied ? t('publicPages.copied') : t('publicPages.copySmiles')}</span>
      </button>
      {haptoBonds ? <p className="smiles-hapto-note">{t('drawingInfo.haptoSmiles')}</p> : null}
    </>
  );
}
